<template>
  <div class="flex flex-col justify-center items-center pt-32 text-gray-600">
    <OImage v-bind="image" />
    <h1 class="ota-h1 mb-2 mt-20" v-text="$t('Error.404.title')" />
    <p class="ota-body" v-text="$t('Error.404.description')" />
    <div class="text-center pt-12">
      <NewButton tag="nuxt-link" :to="$i19n.localePath({ name: '' })">
        {{ $t('Error.404.button') }}
      </NewButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getImagePaths } from '@/utils/general'

const { t: $t } = useI18n()
const { $i19n } = useNuxtApp()

const image = getImagePaths({
  path: '/img/error/404',
  s3: false
})

definePageMeta({
  layout: 'minimal'
})
</script>
